import axios from 'axios';
import profile from 'config/profile';


const baseURL = profile.authUrl + '/api/v1/';

const axiosClient = axios.create({
  baseURL,
  withCredentials: true,
  responseType: 'json'
});


export default axiosClient;
